import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import images from '_images';
import { colors } from '_styles';
import { eventTracker, } from '_helpers';

// import styles
import { triggerCampaign } from '../pages/Campaign/redux/actions';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  padding: 0;
  height: auto;
  overflow: hidden;
  background-color: #fff;
  width: 100%;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Text = styled.p`
  margin: 0;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 1.5em;
  color: #000 !important;
`;

const Link = styled.a`
  color: ${colors.RC_ACTION} !important;

  &:hover {
    color: ${colors.RC_ACTION} !important;
  }
`;

const ContentWrapper = styled.div`
  overflow: hidden;
  border: 1px solid #E7ECEF;
  padding: 7px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${(parentWidth < 531) && css`
    border:none;
    height: auto;
    overflow:hidden;
    display:initial;
  `};
`;

const RcawWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: ${({ hasCampaign }) => ((hasCampaign) ? '105px' : '60px')};
  margin-right: 17px;

  ${(parentWidth < 531) && css`
    display: none;
    margin-right: 0;
  `};
`;

const RcawIcon = styled.img`
  width: 90px;
`;

const TextWrapper = styled.div`
  flex: 1;
  padding-top: 5px;
  margin-right: 10px;
  margin-left: 25px;

  ${(parentWidth < 531) && css`
    display: block;
    padding: 0 6px;
    margin: 0 auto;
    margin-right: 0;

    p {
      font-size: 15px !important;
      line-height: 1.7em;
      text-align: center;
      padding: 0;
    }

  `};
`;

const DownloadButtonWrapper = styled.div`
  padding-top: ${({ hasCampaign }) => ((hasCampaign) ? '10px' : '5px')};
  justify-content: center;
  gap: 5px;
  display: flex;
  align-items:center;


  ${(parentWidth < 531) && css`
    margin: 0 auto;
    margin-top: 15px;
    text-align: center;
    flex-direction: row;
    gap: 5px;
  `};
`;

const IOSLink = styled.a``;

const AndroidLink = styled.a``;

const IOSImage = styled.img`
  width: 110px;
`;

const AndroidImage = styled.img`
  width: 110px;
`;

const Span = styled.span`
  ${(parentWidth < 760) && css`
    display: none; 
  `};
`;

const QrCodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;

  ${parentWidth < 531 && css`
    display: none;
  `};
`;

const QrCodeImage = styled.img`
  width: 100px;
  height: 100px;
`;

// End style

// eslint-disable-next-line no-empty-pattern
const DownloadAppBanner = ({ webappConfig }) => {
  const {
    app_download_message_long,
    app_download_message_short,
    app_download_ios_link,
    app_download_android_link,
    app_download_qr_code,
    app_download_logo,
  } = webappConfig;
  return (
    <Container>
      <ContentWrapper>
        <RcawWrapper>
          <RcawIcon
            // hasCampaign={hasCampaign}
            src={app_download_logo || images.recycleCoachLogo}
            alt="Recycle Coach Logo"
          />
        </RcawWrapper>

        <TextWrapper>
          <Text
            dangerouslySetInnerHTML={{
              __html: parentWidth > 531 ? app_download_message_long : app_download_message_short
            }}
          />
        </TextWrapper>

        <DownloadButtonWrapper>
          {parentWidth < 531 ? (
            <>
              <IOSLink
                target="_blank"
                onClick={() => eventTracker('APP_DOWNLOAD_LINK_CLICK', 'ios')}
                href={app_download_ios_link || 'https://apps.apple.com/us/app/recyclecoach/id1071714967'}
                rel="noreferrer"
                alt="download ios app"
              >
                <IOSImage
                  src={images.iosLogo}
                  alt="download app for ios"
                />
              </IOSLink>

              <AndroidLink
                target="_blank"
                onClick={() => eventTracker('APP_DOWNLOAD_LINK_CLICK', 'android')}
                href={app_download_android_link || 'https://play.google.com/store/apps/details?id=mobi.recyclecoach.worldster.pack'}
                rel="noreferrer"
                alt="download android app"
              >
                <AndroidImage
                  // hasCampaign={hasCampaign}
                  src={images.androidLogo}
                  alt="download app for android"
                />
              </AndroidLink>
            </>
          ) : <QrCodeWrapper><QrCodeImage src={app_download_qr_code} alt="download app" /></QrCodeWrapper>}
        </DownloadButtonWrapper>
      </ContentWrapper>
    </Container>
  );
};

const mapStateToProps = (store) => ({

  selectedLang: store.config.selectedLang,
  webappConfig: store.config.webappConfig,
});

export default connect(
  mapStateToProps,
  (dispatch) => ({
    activateCampaign: () => dispatch(triggerCampaign(true))
  })
)(DownloadAppBanner);
